
import React from 'react';
import { FastingProtocol } from '@/types/fasting';
import { 
  Coffee, 
  Egg, 
  Apple, 
  Moon, 
  Dumbbell, 
  Mountain, 
  Ship, 
  Tent,
  SunMedium,
  Trophy
} from 'lucide-react';

interface FastingGraphicProps {
  protocol: FastingProtocol;
}

export const FastingGraphic: React.FC<FastingGraphicProps> = ({ protocol }) => {
  // Select icon based on protocol duration
  const getGraphic = () => {
    const hours = protocol.durationHours;
    
    if (hours <= 12) {
      return <Coffee className="text-amber-500 animate-pulse" size={44} />;
    } else if (hours <= 16) {
      return <Apple className="text-green-500 animate-pulse" size={44} />;
    } else if (hours <= 18) {
      return <Moon className="text-indigo-500 animate-pulse" size={44} />;
    } else if (hours <= 20) {
      return <Dumbbell className="text-rose-500 animate-pulse" size={44} />;
    } else if (hours <= 24) {
      return <Tent className="text-emerald-500 animate-pulse" size={44} />;
    } else if (hours <= 72) {
      return <Mountain className="text-purple-600 animate-pulse" size={44} />;
    } else {
      return <Ship className="text-fasttrack-blue animate-pulse" size={44} />;
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="relative mt-4 mb-8">
        {getGraphic()}
        <div className="absolute inset-0 bg-gradient-to-br from-transparent to-fasttrack-light-blue/30 rounded-full -z-10" />
      </div>
    </div>
  );
};
